import moment from 'moment';
import store from '../store/store';
import router from '../router';

const handleTimedOut = async () => {
  if (store.getters.isNative) {
    await store.dispatch('refreshToken');
  } else if (router.currentRoute.meta.requiresAuth !== undefined) {
    await router.push({ name: 'logout' });
  }
};

const timeToRefresh = () => {
  let timeout = 59;
  if (store.getters.isNative) {
    timeout = 30;
  }
  return moment().diff(store.getters.tokensUpdated, 'minutes') >= timeout;
};

let hidden;
let visibilityChange;

if (typeof document.hidden !== 'undefined') {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

document.addEventListener(visibilityChange, () => {
  if (document[hidden]) {
    /* TODO Do something with this? */
  } else if (store.getters.tokens && timeToRefresh()) {
    handleTimedOut();
  }
}, false);

window.authTimeoutHandle = setInterval(() => {
  if (store.getters.tokens && timeToRefresh()) {
    handleTimedOut();
  }
}, 30000);

// setTimeout(() => {
//   console.log('Expiring tokens');
//   store.commit('expireTokens');
// }, 15000);
